import React from 'react';

const SubscriptionDowngrade = ({ onCancel, onConfirm, onDowngrade, type, timeout }) => {
    
    const timeoutDate = new Date(timeout);
    const now = new Date();

    // Calculate days difference
    const diffMs = timeoutDate - now;
    // const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffDays = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));

    function formatDate(time) {
    return new Date(time).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}

    return (
        <div className="backwrap">
            <div className="freeliModal">
                <div className="freeliModalHead">
                    <h4 className="popupTitle !font-bold text-[#2440bd]">Subscription downgrade!</h4>
                    <span className="closeModal" onClick={onCancel}></span>
                </div>
                <div className="freeliModalBody">
                    <p className="delDesc !text-base !text-justify !px-[10px]">

                        {type === 'fail' && (
                            <>
                                Your downgrade to a free account will begin in <b>{diffDays}</b> days.
                                Your account is over the restrictions of a free account.
                                To continue, you will have to reduce areas of your account so you can meet
                                the free account limits. We will remind you again before your account downgrade begins.
                            </>
                        )}
                        {/* {type === 'paid' && (
                            <>
                                Your payment was successful! Your subscription is valid until{' '}
                                <b>{formatDate(timeout)}</b>.  
                                You have <b>{diffDays}</b> days remaining to enjoy all premium features without interruption.
                            </>
                        )} */}

                        <br /><br />
                        Would you like to upgrade your plan now?
                    </p>
                </div>
                <div className="freeliModalFoot">
                    <button className="btnCancel" onClick={onDowngrade}>Downgrade now</button>
                    <button className="btnActionConfirm bg-[#2440bd] btnAction hover_bg" onClick={onConfirm}>Upgrade now</button>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionDowngrade;
